import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Header, Footer } from "./components/layout";
import {
  Hero,
  Features,
  LiveProducts,
  MerchantSection,
  FAQ,
  AppDownloadBanner,
} from "./components/sections";
import { SEO } from "./components/SEO";
import { ScrollToTop, PageLoader } from "./components/ui";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Compliance from "./pages/Compliance";
import RefundPolicy from "./pages/RefundPolicy";
import BusinessDetail from "./pages/BusinessDetail";
import DealsPage from "./pages/Deals";
import AllShopsPage from "./pages/AllShops";
import AllOffersServicesPage from "./pages/AllOffersServices";
import ServicesPage from "./pages/Services";
import OfferDetailPage from "./pages/OfferDetail";
import AppRedirect from "./pages/AppRedirect";
import {
  organizationSchema,
  productSchema,
  websiteSchema,
} from "./utils/structuredData";
import "./styles/globals.css";

function HomePage() {
  // Combine multiple structured data schemas
  const combinedStructuredData = {
    "@context": "https://schema.org",
    "@graph": [organizationSchema, productSchema, websiteSchema],
  };

  return (
    <>
      <SEO structuredData={combinedStructuredData} />
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <Hero />
          <Features />
          <LiveProducts />
          <MerchantSection />
          <FAQ />
          <AppDownloadBanner />
        </main>
        <Footer />
      </div>
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <PageLoader />
      <BrowserRouter future={{ v7_startTransition: true }}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/deals" element={<DealsPage />} />
          <Route path="/deals-near-you" element={<DealsPage />} />

          {/* All Shops Pages */}
          <Route path="/shops" element={<AllShopsPage />} />
          <Route path="/all-shops" element={<AllShopsPage />} />
          <Route path="/businesses" element={<AllShopsPage />} />
          <Route path="/businesses/:slug" element={<BusinessDetail />} />
          <Route path="/shops/:slug" element={<BusinessDetail />} />
          <Route path="/shop/:slug" element={<BusinessDetail />} />

          {/* Restaurants Page -> Redirect to Shops with Restaurants category */}
          <Route
            path="/restaurants"
            element={<Navigate to="/shops?category=restaurants" replace />}
          />

          {/* Trusted Services Page */}
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/trusted-services" element={<ServicesPage />} />

          {/* Offer & Deal Details */}
          <Route path="/offers/:id" element={<OfferDetailPage />} />
          <Route path="/offer/:id" element={<OfferDetailPage />} />
          <Route path="/deals/:id" element={<OfferDetailPage />} />
          <Route path="/deal/:id" element={<OfferDetailPage />} />

          {/* All Offers & Combined Pages */}
          <Route path="/offers" element={<AllOffersServicesPage />} />
          <Route path="/all-offers" element={<AllOffersServicesPage />} />
          <Route path="/offers-services" element={<AllOffersServicesPage />} />

          {/* App Download & Referral Sharing Routes */}
          <Route path="/app" element={<AppRedirect />} />
          <Route path="/download" element={<AppRedirect />} />
          <Route path="/invite" element={<AppRedirect />} />

          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="/refund" element={<RefundPolicy />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
